import { createPortal } from 'react-dom';
import { ToastContainer } from 'react-toastify';
import { Outlet } from '@tanstack/react-router';

export default function App() {
  return (
    <>
      {createPortal(<ToastContainer />, document.body)}
      <Outlet />
    </>
  );
}
